export default {
  serviceTestCode: state => state.serviceTestCode,
};
